import {Box, Button, Grid} from '@mui/material';
import {DataItem, ListExpanderSimple} from '../global/ListExpanderSimple';
import {useState} from 'react';
import {t} from 'i18next';
import {useHorses} from '../../hooks/useHorses';
import {compact, get, isEmpty, uniqBy} from 'lodash';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {TUser} from '../../shared/types/user.type';
import {DatePicker} from 'antd';
import {Dayjs} from 'dayjs';

const {RangePicker} = DatePicker;

type FilterProps = {
    selectedHorses: (string | number)[],
    selectedRepport: (string | number)[],
    dateRange: [Dayjs | null, Dayjs | null],
    onChangeHoses: (values: (string | number)[]) => void,
    onChangeRepportType: (values: (string | number)[]) => void,
    onChangeDateRange: (values: [Dayjs | null, Dayjs | null]) => void,
    resetFilters: () => void
}

function Filters({
                     selectedHorses,
                     dateRange,
                     selectedRepport,
                     onChangeDateRange,
                     onChangeHoses,
                     onChangeRepportType,
                     resetFilters
                 }: FilterProps) {
    const isUserLoading = useSelector<RootState>(state => state.user.isUserLoading) as boolean
    const auth = useSelector<RootState>(state => state.user.user) as TUser | null

    const [searchHorses, setSearchHorses] = useState('')

    //Data For Horses
    const {horses, isLoadingHorses} = useHorses(!isUserLoading || false, get(auth, '@id'), {
        horses: {
            pagination: true,
            page: 1,
            itemsPerPage: 30,
            ...(searchHorses ? {'horse.name': searchHorses} : {})
        }
    })

    //Data for repport type
    const repportType: DataItem[] = [
        {
            title: t('training'),
            value: 'TRAINING'
        },
        {
            title: t('navbar:comparison'),
            value: 'GALLOP_REVIEW'
        },
           {
            title: t('repportType:stable'),
            value: 'STABLE_REVIEW'
        },
    ]


    const mappedHorses: DataItem[] = isEmpty(horses) ? [] : uniqBy(horses, horse => horse?.horse?.['@id']).map(horse => ({
        title: horse.horse?.name || "",
        value: horse.horse?.['@id']
    }))

    const filtersLength = compact([...selectedHorses, ...selectedRepport, ...dateRange]).length

    return (
        <Grid container spacing={2}>

            <Grid item md={3} xs={12}>
                <ListExpanderSimple
                    label={t('horses')}
                    data={mappedHorses}
                    checkedValues={selectedHorses}
                    serverSearch
                    onSearch={(value) => setSearchHorses(value)}
                    onChange={(vals) => onChangeHoses(vals)}
                    loading={isLoadingHorses}
                />
            </Grid>
            <Grid item md={3} xs={12}>
                <ListExpanderSimple
                    label={t('repportType')}
                    data={repportType}
                    checkedValues={selectedRepport}
                    onChange={(vals) => onChangeRepportType(vals)}
                />
            </Grid>

            <Grid item md={3} xs={12}>
                <RangePicker
                    value={dateRange}
                    onChange={(dates) => {

                        let _dates = dates || [null, null]

                        onChangeDateRange(_dates as [Dayjs | null, Dayjs | null])
                    }}
                    format="DD/MM/YYYY"
                    className="custom-range-picker"
                    allowClear

                />
            </Grid>
            {
                filtersLength > 0 &&
                <Grid item md={3} xs={12} sx={{placeContent: 'center'}}>
                    <Button onClick={resetFilters} variant='text'>{t('resetFilter')} ({filtersLength})</Button>
                </Grid>
            }
        </Grid>
    )
}


export default Filters